import { formatCurrency, transformDateToLocalDateString } from "helpers";
import { UsageEventRow } from "services/api/finance/usage/types";
import { USAGE_KEY_LABELS } from "services/api/finance/usage/consts";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import UserCell from "ui/components/Table/TableSearch/components/Cells/UserCell";
import VehicleCell from "ui/components/Table/TableSearch/components/Cells/VehicleCell";

export const USAGE_SEARCH_COLUMNS: Column[] = [
  {
    title: "Datum",
    field: "occurredOn",
    type: ColumnTypes.custom,
    render: (row: UsageEventRow) =>
      transformDateToLocalDateString(new Date(row.occurredOn)),
  },
  {
    title: "Vrsta",
    field: "pricingKeyCode",
    type: ColumnTypes.custom,
    // Ključ dolazi iz cjenika; ako se pojavi nov, prikaže se sam ključ umjesto praznine.
    render: (row: UsageEventRow) =>
      USAGE_KEY_LABELS[row.pricingKeyCode] ?? row.pricingKeyCode,
  },
  {
    title: "Predmet",
    field: "subject",
    type: ColumnTypes.custom,
    // Izračun pokazuje vozilo iz kataloga. SMS, OCR i JOM koji katalog ne poznaje ostaju tekst.
    render: (row: UsageEventRow) =>
      row.vehicle ? <VehicleCell vehicle={row.vehicle} /> : row.subject,
  },
  {
    title: "Korisnik",
    field: "userCreatedFullName",
    type: ColumnTypes.custom,
    render: (row: UsageEventRow) => {
      if (!row.userCreatedFullName) return null;

      return (
        <UserCell
          fullName={row.userCreatedFullName}
          userId={row.userCreatedId ?? ""}
        />
      );
    },
  },
  {
    title: "Rezultat",
    field: "isSuccess",
    type: ColumnTypes.custom,
    render: (row: UsageEventRow) =>
      row.isSuccess ? (
        <Badge text="Uspješno" variant="success" showDot />
      ) : (
        <Badge text="Nije uspjelo" variant="warning" showDot />
      ),
  },
  {
    title: "Naplaćeno",
    field: "amount",
    type: ColumnTypes.custom,
    // Neuspio događaj se ne naplacuje, pa nula ovdje ne bi rekla zašto je nula.
    render: (row: UsageEventRow) =>
      row.isSuccess ? formatCurrency.format(row.amount) : "—",
  },
];
